import { FunctionHelpers } from "../gpt/functions/FunctionsHelpers";
import universalstorageHandler from "../persistence/UniversalstorageHandler";
import { createMissingTemplateGroups } from "../models/TemplateGroup";
import { showToast } from "./Toasts";
import { EventKey } from "../eventLogger/EventKeys";
import { loadLanguage } from "../translationItx/itx";

export async function loadProject(projectId: string, loadLocal?: boolean): Promise<Blob | undefined> {
  showToast({
    title: state.translate("homePage.projectLoad", "Projekt wird geladen"),
    text: state.translate("appPage.pleaseWait", "bitte warten"),
    modal: true,
    progress: true,
  });

  let blob: Blob | undefined;
  if (loadLocal) {
    blob = await universalstorageHandler.loadProjectLocal(projectId);
  } else {
    blob = await universalstorageHandler.loadProject(projectId);
  }

  // Template-group migration and translation are part of loading the project.
  // They may change persistent model data but must not create undo steps.
  state.suppressUndoObservation = true;
  try {
    // after loading check if templateGroups are not to much
    // add missing template groups ( decentral Actor is added later ( old Projects need it) )
    createMissingTemplateGroups();
    FunctionHelpers.cleanUpTemplateGroups();

    // Project imports preserve the shared user language; refresh names in the new model.
    await loadLanguage();

    state.translateValueFunctions.translateNamesAfterLanguageSelection();
  } finally {
    state.enableUndoMonitoring();
    state.undoManager.clear();
    state.suppressUndoObservation = false;
  }

  if (blob) {
    state.eventLogger.startSession(state.loggedInUser?.id ?? state.loggedInUser?.email ?? "", projectId);
    state.eventLogger.addEvent(EventKey.ProjectOpened, { projectId });
  }

  return blob;
}
